import {Component, OnDestroy, OnInit} from "@angular/core";
import {GestionGefService} from "../../../core/services/gef/gestion-gef.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {HistoryEventDto} from "../../../core/dtos/history-event-dto";

@Component({
  selector: 'yo-historique-flux-gef',
  templateUrl: './historique-flux-gef.component.html',
  styleUrls: ['./historique-flux-gef.component.scss']
})

export class HistoriqueFluxGefComponent implements OnInit, OnDestroy {

  gefHistoryList: HistoryEventDto[] = [];
  subFindAllGefHistory: Subscription;
  displayDialog: boolean = false;
  selectedLogs: any;

  constructor(private gestionGefSvc: GestionGefService,
              private utilsSvc: UtilsService) {
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subFindAllGefHistory);
  }

  ngOnInit(): void {
    this.subFindAllGefHistory = this.gestionGefSvc.findAllGefHistory().subscribe(results => {
      this.gefHistoryList = results.allGefHistory
    })
  }

  openLogsDialog(log: string) {
    this.selectedLogs = Object.entries(JSON.parse(log)).map(([key, value]) => ({ key, value }));
    this.displayDialog = true;
  }

  closeLogsDialog() {
    this.displayDialog = false;
  }
}
